'use client';
import styled from 'styled-components';

export const Caption = styled.p`
  margin: ${props => props.theme.spacing(...(props.$margin ?? [3, 0]))};
  ${props => props.theme.typography.body};
  display: ${props => (props.$hideCaption ? 'none' : 'block')};

  @media ${props => props.theme.laptop} {
    display: block;
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const StyledQuestion = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(props.$gap)};
  margin-bottom: 0;
  text-align: center;
  width: 100%;
  background-color: ${props =>
    props.$bgColor && props.theme.colors.get(props.$bgColor)};
  padding: ${props => {
    if (props.$padding === null || props.$padding === undefined) {
      return props.theme.spacing(0);
    }
    return Array.isArray(props.$padding)
      ? props.theme.spacing(...props.$padding)
      : props.theme.spacing(props.$padding);
  }};
  border-radius: 32px;
  h2 {
    ${props => props.theme.fontFamily.base}
    margin-bottom: ${props => props.theme.spacing(5)};
  }
`;

export const Subheading = styled.p`
  ${props => props.theme.typography.body};
  margin: ${props => props.theme.spacing(1, 0)};
  display: ${props => (props.$hideSubheadlineOnMobile ? 'none' : 'block')};

  @media ${props => props.theme.laptop} {
    display: block;
  }
`;
